const Enum = {
  active: {
    0: '已禁用',
    1: '已启用'
  },
  pub: {
    0: '未发布',
    1: '已发布'
  },
  yesOrNo: {
    0: '否',
    1: '是'
  },
  role: {
    admin: '管理员',
    worker: '慕课专员',
    teacher: '教师'
  },
  infoCategory: {
    1: '通知公告',
    2: '新闻资讯'
  },
  questionType: {
    1: '单选',
    2: '多选',
    3: '判断'
  },
  questionOption: {
    0: 'A',
    1: 'B',
    2: 'C',
    3: 'D'
  },
  gender: {
    1: '男',
    2: '女'
  },
  courseStatus: {
    1: '建设中',
    2: '待审核',
    3: '审核通过',
    4: '审核不通过',
    5: '已发布'
  },
  scoreCategory: {
    0: '踩',
    1: '赞'
  },
  suggestionCategory: {
    1: '投诉',
    2: '建议',
    3: '咨询'
  },
  videoTaskStatus: {
    1: '草稿',
    2: '等待加工',
    3: '加工中',
    4: '已完成',
    5: '已失败'
  },
  serviceStatus: {
    1: '新建',
    2: '待加工',
    3: '加工中',
    9: '停止'
  },
  taskStatus: {
    1: '草稿',
    2: '等待加工音频',
    3: '音频加工中',
    4: '等待加工视频',
    5: '音频加工失败',
    6: '视频加工中',
    7: '已完成',
    8: '已失败'
  },
  workStatus: {
    1: '草稿',
    2: '等待加工',
    3: '加工中',
    7: '已完成',
    8: '已失败'
  }
}
export default Enum
